import service from '@/store/services/vendors/labourer-issues-service';

const state = {
    list: {},
    labourerIssue: {},
    issues: [],
    issue: null,
    stats: null,
    categories: [],
    statuses: [],
    priorities: [],
    isLoading: false,
    error: null,
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, labourerIssue) => {
        state.labourerIssue = labourerIssue;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    },


    SET_ISSUES(state, issues) {
        state.issues = issues;
    },
    SET_ISSUE(state, issue) {
        state.issue = issue;
    },
    SET_STATS(state, stats) {
        state.stats = stats;
    },
    SET_CATEGORIES(state, categories) {
        state.categories = categories;
    },
    SET_STATUSES(state, statuses) {
        state.statuses = statuses;
    },
    SET_PRIORITIES(state, priorities) {
        state.priorities = priorities;
    },
    SET_LOADING(state, status) {
        state.isLoading = status;
    },
    SET_ERROR(state, error) {
        state.error = error;
    },
    ADD_ISSUE(state, issue) {
        state.issues.unshift(issue);
    },
    UPDATE_ISSUE(state, issue) {
        var index = state.issues.findIndex(function (i) {
            return i.id === issue.id;
        });
        if (index !== -1) {
            state.issues = issue
            // Vue.set(state.issues, index, issue);
        }
    },
    REMOVE_ISSUE(state, issueId) {
        state.issues = state.issues.filter(function (i) {
            return i.id !== issueId;
        });
    }
};

const actions = {
    list({commit, dispatch}, params = {}) {
        return service.list(params)
            .then(({list, meta}) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    get({commit, dispatch}, params) {
        return service.get(params)
            .then(labourerIssue => {
                commit('SET_RESOURCE', labourerIssue);
            });
    },
    show({commit, dispatch}, params) {
        return service.show(params)
            .then(labourerIssue => {
                commit('SET_RESOURCE', labourerIssue);
            });
    },
    add({commit, dispatch}, params) {
        return service.add(params)
            .then((labourerIssue) => {
                commit('SET_RESOURCE', labourerIssue);
            });
    },

    update({commit, dispatch}, params) {
        return service.update(params)
            .then((labourerIssue) => {
                commit('SET_RESOURCE', labourerIssue);
            });
    },

    destroy({commit, dispatch}, params) {
        return service.destroy(params);
    },

    fetchCategories: function ({commit}) {
        commit('SET_LOADING', true);
        return service.getCategories()
            .then(function (response) {
                commit('SET_CATEGORIES', response.data);
                commit('SET_LOADING', false);
                return response;
            })
            .catch(function (error) {
                commit('SET_LOADING', false);
                commit('SET_ERROR', error.message);
                throw error;
            });
    },

    fetchStatuses: function ({commit}) {
        commit('SET_LOADING', true);
        return service.getStatuses()
            .then(function (response) {
                commit('SET_STATUSES', response.data);
                commit('SET_LOADING', false);
                return response;
            })
            .catch(function (error) {
                commit('SET_LOADING', false);
                commit('SET_ERROR', error.message);
                throw error;
            });
    },

    fetchPriorities: function ({commit}) {
        commit('SET_LOADING', true);
        return service.getPriorities()
            .then(function (response) {
                commit('SET_PRIORITIES', response.data);
                commit('SET_LOADING', false);
                return response;
            })
            .catch(function (error) {
                commit('SET_LOADING', false);
                commit('SET_ERROR', error.message);
                throw error;
            });
    },

    fetchIssues: function ({commit}, {labourerId, filters}) {
        console.log(filters);
        console.log(labourerId);
        commit('SET_LOADING', true);
        return service.getIssues(labourerId, filters)
            .then(function (response) {
                commit('SET_ISSUES', response.data);
                commit('SET_STATS', response.stats);
                commit('SET_LOADING', false);
                return response;
            })
            .catch(function (error) {
                commit('SET_LOADING', false);
                commit('SET_ERROR', error.message);
                throw error;
            });
    },

    fetchIssue: function ({commit}, {labourerId, issueId}) {
        commit('SET_LOADING', true);
        return service.getIssue(labourerId, issueId)
            .then(function (response) {
                commit('SET_ISSUE', response.data);
                commit('SET_LOADING', false);
                return response;
            })
            .catch(function (error) {
                commit('SET_LOADING', false);
                commit('SET_ERROR', error.message);
                throw error;
            });
    },

    createIssue: function ({commit}, {labourerId, data}) {
        commit('SET_LOADING', true);
        return service.createIssue(labourerId, data)
            .then(function (response) {
                commit('ADD_ISSUE', response.data);
                commit('SET_LOADING', false);
                return response;
            })
            .catch(function (error) {
                commit('SET_LOADING', false);
                commit('SET_ERROR', error.message);
                throw error;
            });
    },

    updateIssue: function ({commit}, {labourerId, issueId, data}) {
        commit('SET_LOADING', true);
        return service.updateIssue(labourerId, issueId, data)
            .then(function (response) {
                commit('UPDATE_ISSUE', response.data);
                commit('SET_LOADING', false);
                return response;
            })
            .catch(function (error) {
                commit('SET_LOADING', false);
                commit('SET_ERROR', error.message);
                throw error;
            });
    },

    resolveIssue: function ({commit}, {labourerId, issueId, comments}) {
        commit('SET_LOADING', true);
        return service.resolveIssue(labourerId, issueId, comments)
            .then(function (response) {
                commit('UPDATE_ISSUE', response.data);
                commit('SET_LOADING', false);
                return response;
            })
            .catch(function (error) {
                commit('SET_LOADING', false);
                commit('SET_ERROR', error.message);
                throw error;
            });
    },

    closeIssue: function ({commit}, {labourerId, issueId, comments}) {
        commit('SET_LOADING', true);
        return service.closeIssue(labourerId, issueId, comments)
            .then(function (response) {
                commit('UPDATE_ISSUE', response.data);
                commit('SET_LOADING', false);
                return response;
            })
            .catch(function (error) {
                commit('SET_LOADING', false);
                commit('SET_ERROR', error.message);
                throw error;
            });
    },

    reopenIssue: function ({commit}, {labourerId, issueId, comments}) {
        commit('SET_LOADING', true);
        return service.reopenIssue(labourerId, issueId, comments)
            .then(function (response) {
                commit('UPDATE_ISSUE', response.data);
                commit('SET_LOADING', false);
                return response;
            })
            .catch(function (error) {
                commit('SET_LOADING', false);
                commit('SET_ERROR', error.message);
                throw error;
            });
    },

    deleteIssue: function ({commit}, {labourerId, issueId}) {
        commit('SET_LOADING', true);
        return service.deleteIssue(labourerId, issueId)
            .then(function () {
                commit('REMOVE_ISSUE', issueId);
                commit('SET_LOADING', false);
                return true;
            })
            .catch(function (error) {
                commit('SET_LOADING', false);
                commit('SET_ERROR', error.message);
                throw error;
            });
    },

    fetchStats: function ({commit}, labourerId) {
        commit('SET_LOADING', true);
        return service.getStats(labourerId)
            .then(function (response) {
                commit('SET_STATS', response.data);
                commit('SET_LOADING', false);
                return response;
            })
            .catch(function (error) {
                commit('SET_LOADING', false);
                commit('SET_ERROR', error.message);
                throw error;
            });
    },

    clearError: function ({commit}) {
        commit('SET_ERROR', null);
    }
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    labourerIssue: state => state.labourerIssue,
    dropdown: (state) => {
        return state.list.map(labourerIssue => ({
            id: labourerIssue.id,
        }));
    },
    issues: function (state) {
        return state.issues;
    },
    issue: function (state) {
        return state.issue;
    },
    stats: function (state) {
        return state.stats;
    },
    categories: function (state) {
        return state.categories;
    },
    statuses: function (state) {
        return state.statuses;
    },
    priorities: function (state) {
        return state.priorities;
    },
    isLoading: function (state) {
        return state.isLoading;
    },
    error: function (state) {
        return state.error;
    },
    openIssues: function (state) {
        return state.issues.filter(function (i) {
            return i.status === 'open' || i.status === 'in_progress';
        });
    },
    resolvedIssues: function (state) {
        return state.issues.filter(function (i) {
            return i.status === 'resolved';
        });
    },
    closedIssues: function (state) {
        return state.issues.filter(function (i) {
            return i.status === 'closed';
        });
    }
};

const labourerIssues = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default labourerIssues;
